import { Field } from "./Field";
import { SOCIAL_LABELS } from "@/lib/labels";

export const StepSocials = ({ form, update }) => (
  <div>
    <p className="text-sm text-slate-400 mb-6">
      Handles or full profile URLs both work — whatever is easiest.
    </p>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
      {Object.entries(SOCIAL_LABELS).map(([key, label]) => (
        <Field
          key={key}
          label={label}
          testid={`input-social-${key}`}
          placeholder={key === "other" ? "Any other platform + handle" : `@yourhandle`}
          value={form.socials[key]}
          onChange={(e) => update(`socials.${key}`, e.target.value)}
        />
      ))}
    </div>
  </div>
);
